import { OptionItemModel } from "../components/options-filter/models";

export class SelectedFilterOptions {
  /**Глобальные статусы */
  GlobalStatuses: OptionItemModel[] = [];
  /**Проекты */
  Projects: OptionItemModel[] = [];
  /**Теги проекта */
  Tags: OptionItemModel[] = [];
  /**НС проекта */
  Namespaces: OptionItemModel[] = [];
  /**Типы */
  Types: OptionItemModel[] = [];
  /**Сложности */
  Difficultys: OptionItemModel[] = [];
  /**Очереди */
  Queues: OptionItemModel[] = [];
  /**Статусы */
  Statuses: OptionItemModel[] = [];
  /**Приоритеты */
  Priorities: OptionItemModel[] = [];
  /**Скрытые элементы */
  HiddenElements?: OptionItemModel[] = [];

  constructor(obj?: Partial<SelectedFilterOptions>) {
    Object.assign(this, obj);
  }
}
